export default __webpack_public_path__ + "img/catIconDefault.53130f6b.svg";